import { ExternalNotificationType } from '@kcftech/prometheustypescriptapiclient';
import { useMutation } from '@tanstack/react-query';
import { SelectOption } from 'components/forms/Select';
import { DropdownInlineEditor } from 'components/inline_edit/DropdownInlineEditor';
import { useNotificationContext } from 'contexts/NotificationContext';
import { usePermissions } from 'contexts/PermissionsContext';
import { LocationsTableCellProps } from 'pages/Settings/Locations/LocationsTable';
import { useMemo } from 'react';
import { updateLocation } from 'utils/location';

const options = [
    { title: 'Disabled', value: ExternalNotificationType.Disabled },
    { title: 'Enabled - Automatic', value: ExternalNotificationType.Automatic },
    { title: 'Enabled - Manual', value: ExternalNotificationType.Manual },
];

export function LocationExternalNotificationsCell({
    rowData,
    onChange,
}: LocationsTableCellProps) {
    const { canEditLocationDetails } = usePermissions();
    const selectedOption = useMemo(
        () =>
            options.find(
                (role) => role.value === rowData.Settings.ExternalNotificationType
            ),
        [rowData.Settings.ExternalNotificationType]
    );

    const { showToast } = useNotificationContext();
    const { mutate: updateExternalNotification, isPending } = useMutation({
        mutationFn: (externalNotificationType: SelectOption | undefined) =>
            updateLocation(rowData, {
                ExternalNotificationType: externalNotificationType?.value as ExternalNotificationType,
            }),

        onSuccess: () => {
            onChange();
        },

        onError: () =>
            showToast({
                type: 'error',
                content: 'Failed to save location external notification type',
            }),
    });

    return (
        <DropdownInlineEditor
            options={options}
            isDisabled={isPending || !canEditLocationDetails}
            dropdownConfig={{
                renderLabel: ({ value }) => value?.title,
                dataKey: (item) => item.value,
                renderItem: ({ item }) => item.title,
                popup: { width: '20rem' },
            }}
            value={selectedOption}
            renderValue={(value) => value?.title}
            onConfirm={updateExternalNotification}
        />
    );
}
